import { useEffect, useState } from 'react';

//Primereact components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Column
import { ReportsColumns } from '../../appconfig/DatatableSetting';

// Data table

import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { useNavigate } from 'react-router-dom';
import { Badge } from 'primereact/badge';
import { getAction } from '../../appconfig/AppHelper';

export const Reports = () => {
    document.title = 'Reports | GSPC';
    const navigate = useNavigate();
    const [actions, setActions] = useState<any>([]);

    const [reportItmesLength, setReportsItemLength] = useState<any>();

    // use Effect method
    useEffect(() => {
        setActions(getAction('Reports'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const reportsList = [
        {
            id: 0,
            name: 'Application Register',
            type: 'The Application Register Report serves as a comprehensive record of all applications submitted by pharmacists, including services such as new registration, renewal, and other council-related requests.',
            report_name: {
                name: 'Reports',
                count: reportItmesLength
            },
            link: '/app/report/application-register'
        },
        {
            id: 1,
            name: 'Fee Register',
            type: 'The Fee Register Report provides a detailed record of all fee transactions made by pharmacists for various services, including registration, renewal, and other council-related activities.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/fee-register'
        },
        {
            id: 2,
            name: 'Fresh Application Register',
            type: 'The Fresh Application Register Report is a dedicated log of  registration applications submitted by pharmacists.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/fresh-application-register'
        },
        {
            id: 3,
            name: 'Degree Details',
            type: 'The Degree Details Report provides a detailed record of the educational qualifications submitted by pharmacists during the registration process.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/degree-detail'
        },
        {
            id: 4,
            name: 'G Number-Wise Details',
            type: 'The G Number-Wise Details Report provides detailed information about registered pharmacists organized by their unique G Number.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/g-number-wise-detail'
        },
        {
            id: 5,
            name: 'Receipt Download',
            type: 'The Receipt Download Report provides a consolidated view of all  receipts generated for applications and services submitted to the  council.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/receipt-download'
        },
        {
            id: 6,
            name: 'Registration Validation',
            type: 'The Registration Validation Report provides a detailed summary of pharmacists whose registrations have been verified and validated by the council.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/registration-validation'
        },
        {
            id: 7,
            name: 'Application Details',
            type: 'The Application Details Report provides in-depth information about individual applications submitted by pharmacists.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/application-detail'
        },
        {
            id: 8,
            name: 'Statistics Reports',
            type: 'The Statistics Report provides a summarized view of key data and trends related to pharmacist registrations and council services.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/statistics-validation'
        },
        {
            id: 9,
            name: 'Registration Cancellation',
            type: 'Registration Cancellation Report is a detailed document that records all instances where pharmacist registrations have been cancelled or revoked by the council.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/registration-cancellation'
        },

        {
            id: 10,
            name: 'In Out Register Report',
            type: 'The InWard - Outward Register Report maintains a detailed log of all incoming (InWard) and outgoing (Outward) correspondence, documents, and applications handled by the council.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/inout-register-report'
        },
        {
            id: 11,
            name: 'DD Register Reports',
            type: 'DD Register Report is a detailed record that maintains all information related to Demand Drafts (DD) submitted to the Gujarat State Pharmacy Council. ',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/dd-report'
        },
        {
            id: 12,
            name: 'Prov-Org Certificate Registration',
            type: 'Prov-Org Certificate Registration Report is a detailed document that tracks the issuance and registration of both provisional and original certificates to pharmacists',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/provisional-original-report'
        },
        {
            id: 13,
            name: 'College Wise Registration',
            type: 'College Wise Registration Report provides a detailed summary of pharmacist registrations categorized by their respective colleges.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/collegewise-registration'
        },
        {
            id: 14,
            name: 'Government Report',
            type: "The Government Report is an official document that compiles and summarizes key data and activities related to the council's operations, compliance, and regulatory matters.",
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/government-report'
        },
        {
            id: 15,
            name: 'PCI Register',
            type: 'PCI Register Report is an official document maintained by the Pharmacy Council of India (PCI) that contains detailed records of all registered pharmacists and pharmacy institutions under its jurisdiction',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/pci-register'
        },
        {
            id: 16,
            name: 'Record Register',
            type: 'Record Register Report is a detailed document that maintains a systematic log of all registered pharmacists and their professional records.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/record-register'
        },
        {
            id: 17,
            name: 'Electrol Register',
            type: 'The Electoral Register Report is an official record that lists all registered pharmacists eligible to participate in the council’s elections.',
            report_name: {
                name: 'Reports'
            },
            link: '/app/report/electrol-register'
        }
    ];

    const reportsItems = reportsList.filter((item) => item.name && Object.prototype.hasOwnProperty.call(actions, item.name));
  

    useEffect(() => {
        if (!window.cn(reportsItems)) {
            setReportsItemLength(reportsItems.length);
        }
    }, [reportsItems]);

  
    const headerTemplate = (data: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span className="font-bold">{data.report_name.name}</span>
                <Badge value={data.report_name.count}></Badge>
            </div>
        );
    };

    const onRowSelect = (event: any) => {
        navigate(event.data.link);
    };

    const nametemplate = (rowData: any) => {
        return <div style={{ color: '#408dfb', fontWeight: '600' }}>{rowData.name}</div>;
    };

    return (
        <>
            <AppBreadcrumb currentMenu={' Reports'} pageName={'Reports'} />
            <div className="grid crud-demo reports">
                <div className="col-12">
                    <div className="card">
                        <div className="col-12 header">
                            <h4 className="text-bold mb-0">All Reports</h4>
                        </div>
                        <DataTable
                            value={reportsItems}
                            className="datatable-responsive p-datatble-sm"
                            selectionMode="single"
                            onRowSelect={onRowSelect}
                            rowGroupMode="subheader"
                            rowGroupHeaderTemplate={headerTemplate}
                            groupRowsBy="report_name.name"
                            scrollable
                            // scrollHeight="600px"
                        >
                            {ReportsColumns.map((col, i) => {
                                if (col.field === 'name') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={nametemplate} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} />;
                                }
                            })}
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
};
